'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Axis;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _shape = require('@vx/shape');

var _point = require('@vx/point');

var _group = require('@vx/group');

var _center = require('../utils/center');

var _center2 = _interopRequireDefault(_center);

var _identity = require('../utils/identity');

var _identity2 = _interopRequireDefault(_identity);

var _labelTransform = require('../utils/labelTransform');

var _labelTransform2 = _interopRequireDefault(_labelTransform);

var _orientation = require('../constants/orientation');

var _orientation2 = _interopRequireDefault(_orientation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Axis(_ref) {
  var scale = _ref.scale,
      orientation = _ref.orientation,
      _ref$top = _ref.top,
      top = _ref$top === undefined ? 0 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === undefined ? 0 : _ref$left,
      _ref$rangePadding = _ref.rangePadding,
      rangePadding = _ref$rangePadding === undefined ? 0 : _ref$rangePadding,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === undefined ? 'black' : _ref$stroke,
      _ref$strokeWidth = _ref.strokeWidth,
      strokeWidth = _ref$strokeWidth === undefined ? 1 : _ref$strokeWidth,
      strokeDasharray = _ref.strokeDasharray,
      _ref$numTicks = _ref.numTicks,
      numTicks = _ref$numTicks === undefined ? 10 : _ref$numTicks,
      tickFormat = _ref.tickFormat,
      _ref$tickStroke = _ref.tickStroke,
      tickStroke = _ref$tickStroke === undefined ? 'black' : _ref$tickStroke,
      _ref$tickLength = _ref.tickLength,
      tickLength = _ref$tickLength === undefined ? 8 : _ref$tickLength,
      tickTransform = _ref.tickTransform,
      tickValues = _ref.tickValues,
      _ref$hideAxisLine = _ref.hideAxisLine,
      hideAxisLine = _ref$hideAxisLine === undefined ? false : _ref$hideAxisLine,
      _ref$hideTicks = _ref.hideTicks,
      hideTicks = _ref$hideTicks === undefined ? false : _ref$hideTicks,
      _ref$hideZero = _ref.hideZero,
      hideZero = _ref$hideZero === undefined ? false : _ref$hideZero,
      _ref$labelOffset = _ref.labelOffset,
      labelOffset = _ref$labelOffset === undefined ? 14 : _ref$labelOffset,
      labelComponent = _ref.labelComponent,
      _ref$tickLabelCompone = _ref.tickLabelComponent,
      tickLabelComponent = _ref$tickLabelCompone === undefined ? _react2.default.createElement('text', {
    textAnchor: 'middle',
    fontFamily: 'Arial',
    fontSize: 10,
    fill: 'black'
  }) : _ref$tickLabelCompone,
      className = _ref.className;

  var values = scale.ticks ? scale.ticks(numTicks) : scale.domain();
  if (tickValues) values = tickValues;
  var format = scale.tickFormat ? scale.tickFormat() : _identity2.default;
  if (tickFormat) format = tickFormat;

  console.log(!!tickFormat)

  var range = scale.range();
  var range0 = range[0] + 0.5 - rangePadding;
  var range1 = range[range.length - 1] + 0.5 + rangePadding;

  var horizontal = orientation !== _orientation2.default.left && orientation !== _orientation2.default.right;
  var isLeft = orientation === _orientation2.default.left;
  var isTop = orientation === _orientation2.default.top;
  var tickSign = isLeft || isTop ? -1 : 1;

  var position = (scale.bandwidth ? _center2.default : _identity2.default)(scale.copy());

  var axisFromPoint = new _point.Point({
    x: horizontal ? range0 : 0,
    y: horizontal ? 0 : range0
  });
  var axisToPoint = new _point.Point({
    x: horizontal ? range1 : 0,
    y: horizontal ? 0 : range1
  });

  var tickLabelFontSize = tickLabelComponent.props.fontSize || 10;

  var labelTransform = (0, _labelTransform2.default)({
    tickLength: tickLength,
    labelComponent: labelComponent,
    labelOffset: labelOffset,
    tickLabelFontSize: tickLabelFontSize,
    orientation: orientation,
    range: range
  });

  return _react2.default.createElement(
    _group.Group,
    {
      className: (0, _classnames2.default)('vx-axis', className),
      top: top,
      left: left
    },
    labelComponent && _react2.default.cloneElement(labelComponent, labelTransform),
    values.map(function (val, i) {
      if (hideZero && val === 0) return null;

      var tickFromPoint = new _point.Point({
        x: horizontal ? position(val) : 0,
        y: horizontal ? 0 : position(val)
      });
      var tickToPoint = new _point.Point({
        x: horizontal ? position(val) : tickSign * tickLength,
        y: horizontal ? tickLength * tickSign : position(val)
      });
      var tickLabelProps = {
        x: tickToPoint.x,
        y: tickToPoint.y + (horizontal && !isTop ? tickLabelFontSize : 0)
      };

      return _react2.default.createElement(
        _group.Group,
        {
          key: 'vx-tick-' + val + '-' + i,
          className: 'vx-axis-ticks',
          transform: tickTransform
        },
        !hideTicks && _react2.default.createElement(_shape.Line, {
          from: tickFromPoint,
          to: tickToPoint,
          stroke: tickStroke || stroke
        }),
        _react2.default.cloneElement(tickLabelComponent, tickLabelProps, format(val, i))
      );
    }),
    !hideAxisLine && _react2.default.createElement(_shape.Line, {
      from: axisFromPoint,
      to: axisToPoint,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray
    })
  );
}



//////////////////
// WEBPACK FOOTER
// ./~/@vx/axis/build/axis/Axis.js
// module id = ./node_modules/@vx/axis/build/axis/Axis.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000